enum IntegrationEnum {
  HZMO = 1,
  HZJZ = 2,
  MUP = 3,
  MHB = 4,
  MUP1 = 5,
  MUP2 = 6,
  MUP3 = 7,
  ParentChild = 8,
}

export default IntegrationEnum;
